
























import moment from 'moment';
import Vue, { PropType } from 'vue';
import CourseraService from '~/services/CourseraService';
import URLS from '~/URLS';

export default Vue.extend({
    name: 'EnrollButton',
    props: {
        url: {
            type: String,
            required: true,
        },
        nextSessionStart: {
            type: Date as PropType<Date>,
            default: null,
        },
        nextSessionEnd: {
            type: Date as PropType<Date>,
            default: null,
        },
    },
    data() {
        return {
            loading: true,
            access: false,
        };
    },
    computed: {
        inProgress(): boolean {
            if (this.nextSessionStart === null || this.nextSessionEnd === null) return false;
            const now = new Date().getTime();
            return this.nextSessionStart.getTime() >= now && this.nextSessionEnd.getTime() <= now;
        },
        upcoming(): string | null {
            if (this.nextSessionStart === null) return null;
            return moment(this.nextSessionStart).format('MMM Do');
        },
    },
    methods: {
        handleEnroll() {
            if (this.access) window.open(this.url, '_blank');
            else this.$router.push(URLS.courseraChooseSubscription);
        },
    },
    mounted() {
        CourseraService.checkHasAccess()
            .then(access => (this.access = access.access))
            .catch(console.error)
            .finally(() => (this.loading = false));
    },
});
